import React from "react";
//import useFetch from '../hooks/useFetch'
//import url from '../config'

//import NavbarPage from '../components/NavbarPage'
import FooterPage from "../components/FooterPage";
//import { Link } from "react-router-dom"
import url from "../components/config/Config";
import {
    MDBContainer,
    MDBBadge,
    MDBRow,
    MDBCol,
    MDBSelect,
    MDBSelectInput,
    MDBSelectOptions,
    MDBSelectOption,
    MDBSpinner,
} from "mdbreact";

import ListaProductos from "../components/productos/ListaProductos";
import { BarraCategoria } from "../components/categoria/BarraCategoria";
import { NavFiltrosProductos } from "../components/navbar/NavFiltrosProductos";

class Categoria extends React.Component {
    constructor(props) {
        super(props);

        //let bookId = this.props.match.params // aqui vienen los parametros
        // let book = FindBookById(bookId)
        //console.log("PARAMETRO URL : "+bookId.bookId)
        // this.setState({ idCategoria: bookId.bookId});
        // const querystring = window.location.search
        // const params = new URLSearchParams(querystring)
        // console.log(params.get('id'))
        this.state = {
            listaProductos: [],
            llave: url.llavedefault,
            listaCategorias: [],
            loadingProducts: false,
            modalSidebarFiltros: false,
        };
    }

    componentDidMount() {
        this.listaCategoria();
        this.listaProductos4 = this.listaProductos4.bind(this);
        this.listaProductos4(this.props.match.params.bookId);
        this.handleOrdenChange = this.handleOrdenChange.bind(this);
        this.setModalSidebarFiltros = this.setModalSidebarFiltros.bind(this);
    }

    listaProductos4(id) {
        // console.log(id);
        // return;
        this.listaProductosPorCategoria(id);
        this.setModalSidebarFiltros( false );
        //console.log(this.state.listaProductos.length);
        // let item = ["", "", "", ""];
        // let listaGral = [];
        // let acu = 1;
        // this.state.listaProductos.map((prod, i) => {
        //     //console.log(prod+" "+i)
        //     item[i % 4] = prod;
        //     if (i % 4 == 3) {
        //         listaGral.push({ datos: item, i: acu });
        //         acu++;
        //         item = ["", "", "", ""];
        //     }
        // });

        // if (this.state.listaProductos.length % 4 != 4) {
        //     listaGral.push({ datos: item, i: acu });
        //     //console.log("ËNTRO CON MENOS DE 4 prod")
        // }
        // //console.log("ENTROP OTRA VEZ : "+this.props.match.params.bookId)
        // //console.log(this.state.listaProductos.length)

        // return listaGral;
    }
    listaProductosPorCategoria(id) {
        this.setState({ listaProductos: [] });
        this.setState({ loadingProducts: true });
        let datos = {
            accion:
                this.props.match.params.tipo == 1
                    ? "listarPorCategoria"
                    : "listarPorBusqueda",
            llave: this.state.llave,
            idcategoria:
                this.props.match.params.tipo == 1
                    ? id
                    : this.props.match.params.nombrec,
        };
        fetch(url.service + "producto", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(datos),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({ listaProductos: Array.from(responseJson) });
                this.setState({ loadingProducts: false });
            });
    }

    listaCategoria() {
        // console.log(this.props.match.params.bookId);
        let datos = {
            accion: "listarCategoriaItems",
            llave: this.state.llave,
        };
        fetch(url.service + "categoria", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(datos),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({ listaCategorias: Array.from(responseJson) });
            });
    }

    handleOrdenChange(e) {
        if (e.target.value == "3") {
            const ordenados = [...this.state.listaProductos].sort(
                (a, b) => parseFloat(a.precio) - parseFloat(b.precio)
            );
            this.setState({ listaProductos: ordenados });
        }
        if (e.target.value == "4") {
            const ordenados = [...this.state.listaProductos].sort(
                (a, b) => parseFloat(b.precio) - parseFloat(a.precio)
            );
            this.setState({ listaProductos: ordenados });
        }
    }
    setModalSidebarFiltros( state ) {
        this.setState({ modalSidebarFiltros: state });
    }

    render() {
        return (
            <>
                <div
                    style={{ margin: "40px 0" }}
                    className="bg-white max-w-[1400px] mx-auto"
                >
                    <div className="grid grid-cols-2 lg:grid-cols-8 gap-4">
                        <div className="hidden lg:block lg:col-span-2">
                            <BarraCategoria
                                listaCategorias={this.state.listaCategorias}
                                categoriaActual={
                                    this.props.match.params.nombrec
                                }
                                listaProductos4={this.listaProductos4}
                            />
                        </div>
                        <div className="col-span-2 lg:col-span-6 px-3 lg:px-0">
                            <div>
                                <a href="/" className="text-sm text-gray-400">
                                    Hogar / Categoría /
                                </a>
                                <span className="font-semibold text-sm hover:text-secondary-personalize">
                                    {" "}
                                    "
                                    {url.capitalizeWords(
                                        this.props.match.params.nombrec
                                    )}
                                    "
                                </span>
                            </div>

                            <NavFiltrosProductos
                                modalSidebarFiltros={
                                    this.state.modalSidebarFiltros
                                }
                                setModalSidebarFiltros={
                                    this.setModalSidebarFiltros
                                }
                                listaCategorias={this.state.listaCategorias}
                                categoriaActual={
                                    this.props.match.params.nombrec
                                }
                                listaProductos4={this.listaProductos4}
                            />
                            <div className="mb-2">
                                <div className="block lg:flex justify-between">
                                    <div className="flex items-center justify-between">
                                        <p className="text-xl lg:text-2xl font-bold py-2">
                                            {url.capitalizeWords(
                                                this.props.match.params.nombrec
                                            )}
                                        </p>
                                        <span
                                            onClick={ () => this.setModalSidebarFiltros(true) }
                                            className="block lg:hidden"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-funnel-icon lucide-funnel"
                                            >
                                                <path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
                                            </svg>
                                        </span>
                                    </div>
                                    <select
                                        className=" py-2 px-4 border-none bg-white border rounded-sm"
                                        onChange={this.handleOrdenChange}
                                    >
                                        <option value="1" className="">
                                            El más nuevo
                                        </option>
                                        <option value="2" className="">
                                            Más antiguo
                                        </option>
                                        <option value="3" className="">
                                            Precio de barato a caro
                                        </option>
                                        <option value="4" className="">
                                            Precio mayor a menor
                                        </option>
                                    </select>
                                </div>
                            </div>
                            {this.state.loadingProducts && (
                                <div className="flex items-center justify-center">
                                    <MDBSpinner red big crazy />+
                                </div>
                            )}
                            {this.state.listaProductos.length > 0 && (
                                <ListaProductos
                                    listaProductos={this.state.listaProductos}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <FooterPage />
            </>
        );
    }
}

export default Categoria;
